export default function ArrowLeftIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 48 48"
        >
            <path fill="#fff" fillOpacity="0.01" d="M0 0h48v48H0z"></path>
            <path
                stroke="#7A7A7A"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="4"
                d="M5.799 24h36M17.799 36l-12-12 12-12"
            ></path>
        </svg>
    )
}